import {
    COLOR_palette_background_default,
    COLOR_palette_background_paper,
    COLOR_palette_commom_black,
    COLOR_palette_commom_white,
    COLOR_palette_error_contrastText,
    COLOR_palette_error_dark,
    COLOR_palette_error_light,
    COLOR_palette_error_main,
    COLOR_palette_primary_contrastText,
    COLOR_palette_primary_dark,
    COLOR_palette_primary_light,
    COLOR_palette_primary_main,
    COLOR_palette_secondary_contrastText,
    COLOR_palette_secondary_dark,
    COLOR_palette_secondary_light,
    COLOR_palette_secondary_main,
    COLOR_palette_text_disabled,
    COLOR_palette_text_hint,
    COLOR_palette_text_primary,
    COLOR_palette_text_secondary
} from "./colors";

export const palette = {

        "common": {
            "black": COLOR_palette_commom_black,
            "white": COLOR_palette_commom_white
        },
        "background": {
            "paper": COLOR_palette_background_paper,
            "default": COLOR_palette_background_default
        },
        "primary": {
            "light": COLOR_palette_primary_light,
            "main": COLOR_palette_primary_main,
            "dark": COLOR_palette_primary_dark,
            "contrastText": COLOR_palette_primary_contrastText
        },
        "secondary": {
            "light": COLOR_palette_secondary_light,
            "main": COLOR_palette_secondary_main,
            "dark": COLOR_palette_secondary_dark,
            "contrastText": COLOR_palette_secondary_contrastText
        },
        "error": {
            "light": COLOR_palette_error_light,
            "main": COLOR_palette_error_main,
            "dark": COLOR_palette_error_dark,
            "contrastText": COLOR_palette_error_contrastText
        },
        "text": {
            "primary": COLOR_palette_text_primary,
            "secondary": COLOR_palette_text_secondary,
            "disabled": COLOR_palette_text_disabled,
            "hint": COLOR_palette_text_hint
        }

}
